import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useOrpc } from '@/_shared/hooks/useOrpc';

import { applyChatTitle, isChatGone } from '../lib/apply-chat-title';

/** Keep the header, sidebar and chat list in sync after either rename entry point succeeds. */
export function useChatRename() {
  const orpc = useOrpc();
  const queryClient = useQueryClient();
  return useMutation({
    // `always` so an offline attempt fails and surfaces its toast. The default `online` parks the
    // mutation as paused-and-pending, which leaves the dialog locked with no way out.
    networkMode: 'always',
    ...orpc.chat.rename.mutationOptions({
      onSuccess: ({ id, title }) => {
        // A patch, no refetch: the mutation just returned the authoritative name, and the rename
        // leaves `updated_at` alone so the list order cannot have moved.
        applyChatTitle(queryClient, orpc, id, title);
        // Under an active search filter the renamed row leaves the list, which on its own reads as a
        // deletion. The delete flow toasts too.
        toast.success('Chat renamed');
      },
      onError: (err) =>
        toast.error(
          isChatGone(err)
            ? 'This chat can no longer be renamed. It may have been deleted.'
            : err instanceof Error
              ? err.message
              : 'Failed to rename chat',
        ),
    }),
  });
}
